import { Link } from 'react-router-dom';

import logo from '@/assets/logo.jpg';
import { ROUTES } from '@/utils/constants';

interface LogoProps {
  to?: string;
  showWordmark?: boolean;
  // Lets a drawer close itself when the logo is used as a nav target.
  onClick?: () => void;
}

const Logo = ({ to = ROUTES.LANDING, showWordmark = true, onClick }: LogoProps) => (
  <Link
    to={to}
    onClick={onClick}
    aria-label="AdvisorKhoj home"
    className="flex min-h-11 items-center gap-2.5 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 sm:min-h-0"
  >
    <span className="grid h-9 w-9 place-items-center overflow-hidden rounded-xl ring-1 ring-line">
      <img src={logo} alt="AdvisorKhoj logo" className="h-full w-full object-contain" />
    </span>
    {showWordmark && (
      <span className="leading-tight">
        <span className="block text-sm font-extrabold tracking-tight text-ink">AdvisorKhoj</span>
        <span className="block text-[10px] font-semibold uppercase tracking-wider text-ink/50">
          MIS CRM
        </span>
      </span>
    )}
  </Link>
);

export default Logo;
